import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Icon from './../Icon';
import CollapseItem from './CollapseItem';
import MySubjectsForm from './MySubjectsForm';
import NotificationsForm from './NotificationsForm';
import PaymentInfoForm from './PaymentInfoForm';
import PersonalInfoForm from './PersonalInfoForm';
import TimezoneDropdown from './TimezoneDropdown';
// import AvailabilityDropdown from './AvailabilityDropdown';
import CountryDropdown from './CountryDropdown';
import UniversityDropdown from './UniversityDropdown';
import MajorDropdown from './MajorDropdown';
import ExperienceDropdown from './ExperienceDropdown';
import CellOsDropdown from './CellOsDropdown';
import EmailDropdown from './EmailDropdown';
import PhoneDropdown from './PhoneDropdown';
import SkypeDropdown from './SkypeDropdown';
import PasswordDropdown from './PasswordDropdown';
import PhoneVerificationDropdown from './PhoneVerificationDropdown';

import Modal from './../Modal';

import { userFetchIfNeeded, userSetFieldFetch } from './../../store/user/actions';

const bodyNoScrollClass = 'hide-scroll-profile';

class ProfileInner extends Component {
    componentDidMount() {
        const { load } = this.props;
        load();
        document.body.classList.add(bodyNoScrollClass);
    }

    componentWillUnmount() {
        document.body.classList.remove(bodyNoScrollClass);
    }

    renderContent() {
        const { profile } = this.props;
        return (
            <div className="order-detail-body person-info-box">
                <div className="person-info-head">
                    <div className="row person-common-info">
                        <div className="col-1">
                            <ul>
                                <li><CountryDropdown /></li>
                                <li><TimezoneDropdown /></li>
                                {/* <li><AvailabilityDropdown /></li> */}
                                <li><CellOsDropdown /></li>
                            </ul>
                        </div>
                        <div className="col-1">
                            <ul>
                                <li><UniversityDropdown /></li>
                                <li><MajorDropdown /></li>
                                <li><ExperienceDropdown /></li>
                            </ul>
                        </div>
                    </div>
                    <h4>Contact info:</h4>
                    <div className="row person-contact-info vertical">
                        <div className="person-contact-info-item contact-info-email">
                            <EmailDropdown />
                            <Icon className="svg-icon" iconName="devider" />
                        </div>
                        <div className="person-contact-info-item contact-info-phone">
                            <PhoneDropdown />
                            <PhoneVerificationDropdown />
                            <Icon className="svg-icon" iconName="devider" />
                        </div>
                        <div className="person-contact-info-item contact-info-skype">
                            <Icon className="svg-icon" iconName="skype" />
                            <SkypeDropdown />
                            <Icon className="svg-icon" iconName="devider" />
                        </div>
                        <div className="person-contact-info-item contact-info-password">
                            <PasswordDropdown />
                        </div>
                    </div>
                </div>
                <CollapseItem title="Payment Info">
                    <PaymentInfoForm />
                    <PersonalInfoForm />
                </CollapseItem>
                <CollapseItem title="My subjects" isError={!profile.subjects || !profile.subjects.length}>
                    <MySubjectsForm />
                </CollapseItem>
                <CollapseItem title="Notifications">
                    <NotificationsForm />
                </CollapseItem>
            </div>
        );
    }

    render() {
        const { profile, onClose } = this.props;
        const isLoading = !profile || profile.isFetching || profile.didInvalidate;
        return (
            <div>
                <div className="order-tab">
                    <div className="order-tab-head">
                        {!isLoading &&
                            <span className="person-info"><b>Grader</b> {profile.name} <i>(WR ID: {profile.wr_id})</i></span>
                        }
                        <button className="btn btn-close" onClick={onClose}><Icon className="svg-icon" iconName="close" /></button>
                    </div>
                    <div className="order-tab-container">
                        {isLoading
                            ? <div className="order-tab-loading"><p>Loading profile details</p></div>
                            : this.renderContent()
                        }
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    profile: state.user
});
const mapDispatchToProps = dispatch => ({
    load: () => dispatch(userFetchIfNeeded()),
});

const ProfileInnerConnected = connect(mapStateToProps, mapDispatchToProps)(ProfileInner);

class Profile extends Component {
    constructor(props) {
        super(props);
        this.onClose = this.onClose.bind(this);
    }

    openRoute() {
        const { location, history } = this.props;
        const searchParams = new URLSearchParams(location.search);
        if (searchParams.has('profile')) {
            return;
        }
        const searchFromParams = searchParams.toString();
        const newSearch = !searchFromParams ? ('?profile') : `?${searchFromParams}&profile`;
        history.push(location.pathname + newSearch);
    }

    onClose() {
        const { history, location } = this.props;
        const searchParams = new URLSearchParams(location.search);
        searchParams.delete('profile');
        const searchFromParams = searchParams.toString();
        const newSearch = !searchFromParams ? '' : `?${searchFromParams}`;
        history.push(location.pathname + newSearch);
    }

    render() {
        const { hasRouteVisible, showAgreementWizard } = this.props;
        if (!hasRouteVisible || showAgreementWizard) {
            return null;
        }
        return (
            <ProfileInnerConnected onClose={this.onClose} />
        );
    }
}

export default withRouter(connect((state, ownProps) => {
    const { user } = state;
    const { location } = ownProps;
    const showAgreementWizard = state.user.showAgreementWizard;
    const hasRouteVisible = (new URLSearchParams(location.search)).has('profile');
    return { hasRouteVisible, showAgreementWizard };
})(Profile));



// WEBPACK FOOTER //
// ./src/components/profile/Profile.js